// Feature flags for controlling MVP vs Post-MVP features
// Set to true to enable revenue-related features when ready

export const features = {
  // Revenue tracking and display
  revenue: false,

  // Profiles section (ICP / Low Converting) - depends on revenue data
  profiles: false,

  // Conversion badges in visitor table
  conversionBadges: false,

  // Revenue columns in distribution charts
  revenueCharts: false,
}
